import { CancellationToken } from '@cian/http-api/shared';
import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { useFileReader } from './hooks';
import { setSendMessageAbort } from '../../actions/sendMessage';
import { retrySendMessageById } from '../../actions/sendMessage/retrySendMessageById';
import { ChatImageDraft } from '../../components/ChatImageDraft';
import { currentOpenChatIDSelector } from '../../selectors';
import { TMessageSchema } from '../../types/messages';

interface IChatImageProps {
  file: File;
  messageId: string;
  cancellationToken: CancellationToken;
  isMessageLoading: boolean;
  isMessageFailed: boolean;
  isGalleryItem?: boolean;
}

export const ChatImageDraftContainer: React.VFC<IChatImageProps> = ({
  file,
  messageId,
  cancellationToken,
  isMessageLoading,
  isMessageFailed,
  isGalleryItem,
}) => {
  const chatId = useSelector(currentOpenChatIDSelector);

  const dispatch = useDispatch();

  const { image, isLoading, isError } = useFileReader(file);

  const handleCancel = () => {
    cancellationToken.cancel();
    dispatch(setSendMessageAbort({ message: { chatId } as TMessageSchema, messageId }));
  };

  const handleReload = React.useCallback(() => {
    dispatch(retrySendMessageById(chatId as string, messageId));
  }, [chatId, dispatch, messageId]);

  return (
    <ChatImageDraft
      image={image}
      isError={isError}
      withCancel={isMessageLoading}
      onCancel={handleCancel}
      withReload={isMessageFailed}
      onReload={handleReload}
      isLoading={isLoading || isMessageLoading}
      isGalleryItem={isGalleryItem}
    />
  );
};
